import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { ChevronDown } from '@/assets/icons'
import { useSendStore } from '@/store/useSendStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import { useTheme } from '@/hooks/useTheme'

export const SendCurrencySelector: React.FC = () => {
  const theme = useTheme()
  const selectedCurrency = useSendStore((state) => state.selectedCurrency)
  const setSelectedCurrency = useSendStore((state) => state.setSelectedCurrency)
  const setCryptoAmount = useSendStore((state) => state.setCryptoAmount)
  const setFiatAmount = useSendStore((state) => state.setFiatAmount)
  const setIsFiatMode = useSendStore((state) => state.setIsFiatMode)
  const setIsCurrencyModalOpen = useSendStore(
    (state) => state.setIsCurrencyModalOpen,
  )
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  const handleCurrencyPress = () => {
    setIsCurrencyModalOpen(true)
  }

  const handleChangeCurrency = (currencyData: any) => {
    setSelectedCurrency(currencyData)
    setCryptoAmount({
      amount: '0',
      code: currencyData.code,
    })
    setFiatAmount({
      amount: '0',
      code: displayCurrency?.isin || 'USD',
    })
    setIsFiatMode(true)
  }

  if (!selectedCurrency) {
    return null
  }

  return (
    <BaseView center mt={12} mb={6}>
      <BaseView
        onClick={handleCurrencyPress}
        className="cursor-pointer hover:opacity-80 transition-opacity duration-200 active:scale-95"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          borderRadius: 24,
          paddingTop: 6,
          paddingBottom: 6,
          paddingLeft: 12,
          paddingRight: 12,
          flexDirection: 'row',
          alignItems: 'center',
          gap: 8,
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        {/* Код валюты */}
        <BaseText
          fontSize={16}
          fontFamily="bold"
          color="white"
          style={{
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        >
          {selectedCurrency.code}
        </BaseText>

        {/* Стрелка вниз */}
        <ChevronDown
          size={16}
          color="white"
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
          }}
        />
      </BaseView>
    </BaseView>
  )
}
